import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon } from '@heroicons/react/24/outline';
import { ChatBubbleOvalLeftEllipsisIcon } from '@heroicons/react/24/outline';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

const MobileBottomMenu = () => {
  return (
    <div className="fixed inset-x-0 bottom-0 z-50 flex items-center justify-around border-t bg-white py-3 shadow-md sm:hidden">
      <a
        href="tel:+393513631080"
        className="flex flex-col items-center text-sm text-gray-700 hover:text-blue-600"
      >
        <PhoneIcon className="mb-1 size-6" />
        Chiama
      </a>

      <a
        href="https://wa.me/+393513631080"
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-col items-center text-sm text-gray-700 hover:text-green-600"
      >
        <ChatBubbleOvalLeftEllipsisIcon className="mb-1 size-6" />
        WhatsApp
      </a>

      <Link
        to="/contatti"
        className="flex flex-col items-center text-sm text-gray-700 hover:text-indigo-600"
      >
        <EnvelopeIcon className="mb-1 size-6" />
        Contattaci
      </Link>
    </div>
  );
};

export default MobileBottomMenu;
